import React from "react";
import { useMediaQuery } from "@mui/material";
import Datavio from "../../Assests/Images/datavio.png";
import Techcurators from "../../Assests/Images/techcuratorsbg.png";
import MBS from "../../Assests/Images/mbs-studios.png";

function Section6() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  // Data for each internship/project
  const projects = [
    {
      image: Datavio,
      title: "Software Engineer",
      date: "May 2023 - Current",
      url: "https://datavio.co/",
      description: [
        "Developed frontend and backend services for Datavio, and transitioned the monolithic architecture to a microservices-based architecture.",
        "Led the development and maintenance of a Chrome extension (with 2000+ users) that helps to analyze product listings on Flipkart.",
        "Streamlined database transactions by implementing Redis locks and utilized caching for optimizing API calls up to 200%.",
        "Implemented a role-based access control system, including user and admin roles, and introduced a subscription model to restrict certain app functionalities to users, thereby enhancing data access authority.",
        "Established CI/CD pipelines with Jenkins to automate Cronjobs for extracting live marketplace data, enhancing development efficiency.",
      ],
    },
    {
      image: Techcurators,
      title: "Project Management Intern",
      date: "Aug 2022 - Jan 2023",
      url: "https://techcurators.in/",
      description: [
        "Collaborated on the development of a new B2B product from scratch.",
        "Created and Implemented A/B testing and MVT (Multivariate Testing) which improved the conversion rate by 30%.",
        "Implemented a new client pitching method, yielding a 25% increase in clients.",
        "Conducted 5+ Coding Contests and Tech quizzes.",
      ],
    },
    {
      image: MBS,
      title: "Game Developer Intern",
      date: "August 2022",
      url: "https://mbsstudios.com/",
      description: [
        "Worked on designing a AAA title game, created assets and models, and brought unique ideas to life.",
        "Designed an Island with 10+ mesh and components like Mountain, River, Ocean, Trees, Grass, etc. using Unreal Engine.",
        "Engineered various working functionalities like physics, oscillations, and motions on the Island using C++ and Blueprints.",
      ],
    },
  ];

  return (
    <section
      style={{
        marginTop: isSmallScreen ? "-7rem" : "-14rem", // Adjusted marginTop for smaller screens
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "5%",
        marginBottom: "5rem",
      }}
    >
      <div
        style={{
          //   width: "100%",
          color: "#141c3a",
          display: "block",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row", // Adjusted flexDirection based on screen size
            justifyContent: "center",
            textAlign: "center",
            height: "100%",
          }}
        >
          {projects.map((project, index) => (
            <div
              key={index}
              style={{
                height: "initial",
                width: isSmallScreen ? "" : "32%", // Adjusted width for smaller screens
                backgroundColor: "white",
                borderRadius: "20px",
                boxShadow:
                  "0 5px 5px 0 rgba(233, 240, 243, 0.5), 0 0 0 1px #E6ECF8",
                color: "#141c3a",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                margin: isSmallScreen ? "0 0 2rem" : index === 1 ? "0 2%" : "0", // Adjusted margin for smaller screens
                padding: "60px 40px",
                marginBottom: isSmallScreen ? "2rem" : "0", // Adjusted marginBottom for smaller screens
              }}
            >
              <div onClick={() => window.open(project.url, "_blank")} style={{cursor:"pointer"}}>
                <img src={project.image} alt={project.title} height="60px" />
              </div>
              <h1
                style={{
                  fontFamily: "Font1",
                  fontWeight: "800",
                  fontSize: "24px",
                  marginTop: "50px",
                  marginBottom: "0px",
                  letterSpacing: "1px",
                  color: "#141c3a",
                }}
              >
                {project.title}
              </h1>
              <p
                style={{
                  fontSize: "16px",
                  margin: "10px 0px 8px",
                  fontFamily: "Font2",
                  color: "#6E07F3",
                }}
              >
                {project.date}
              </p>
              <ul style={{ listStyleType: "initial", marginTop: "50px" }}>
                {project.description.map((item, idx) => (
                  <>
                    <li
                      key={idx}
                      style={{ textAlign: "left", lineHeight: 1.5 }}
                    >
                      {item}
                    </li>
                    <br />
                  </>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Section6;
